module.exports = __webpack_public_path__ + "static/media/icon1.a68e15b0.png";